import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    CvReimportPage: lazyLoad(async () => {
        const { CvReimport } = await import('./index');

        return { default: CvReimport };
    }),
    CvReimportPreviewPage: lazyLoad(async () => {
        const { CvReimportPreview } = await import('./CvReimportPreview');

        return { default: CvReimportPreview };
    }),
    CvReimportResultsPage: lazyLoad(async () => {
        const { CvReimportResults } = await import('./CvReimportResults');

        return { default: CvReimportResults };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.cv-reimport.headline',
        page: lazy.CvReimportPage,
        path: route.patterns.cvReimport,
    },
    {
        documentTitle: 'pages.cv-reimport.preview.sub-headline',
        page: lazy.CvReimportPreviewPage,
        path: route.patterns.preview,
    },
    {
        documentTitle: 'pages.cv-reimport.result.sub-headline',
        page: lazy.CvReimportResultsPage,
        path: route.patterns.results,
    },
];
